import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { usersAPI } from 'features/users/api'
import { usersUsersEmployersList } from './slice'
import { RequestUtils } from 'utils'

function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'employerProfile', 'subscription'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(usersAPI.getEmployers, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        usersUsersEmployersList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(usersUsersEmployersList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(usersUsersEmployersList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(usersUsersEmployersList.getList, getList)
}

function* cleanState() {
  yield put(usersUsersEmployersList.cleanState({}))
}

export function* listSaga() {
  yield all([fork(watchGetList)])
}
